var a = /* @__PURE__ */ ((e) => (e.medium = "medium", e.small = "small", e))(a || {});
function l(e) {
  const s = ["progress"];
  switch (e.hasCompletedState && e.value && e.max && e.value >= e.max && s.push("progress-completed"), e.invalid && s.push("progress-invalid"), e.size) {
    case "small":
      s.push("progress-sm");
      break;
    default:
    case "medium":
      s.push("progress-md");
  }
  return s.join(" ");
}
export {
  a as ProgressSizes,
  l as getProgressStyleClasses
};
